import React from 'react';
import CustomImage from '../../../components/custom-image';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const FirmFoundationOurBoard = () => {
  return (
    <div className="our-board">
      <div className="container-1440">
        <div className="container">
          <div className="container-inner">
            <ScrollPositionAnimation targetElement1="anim-6" targetElement2="anim-7">
              <div className="content-row">
                <div className="column-55">
                  <div className="left-content">
                    <div className="bottom-to-top anim-7">
                      <div className="description">
                        <p>
                          Our Board provides entrepreneurial leadership for the Company and strategic direction to the
                          management. It is collectively responsible for promoting the long-term success of the Company
                          through the creation and delivery of sustainable shareholder value. The reporting structure,
                          as shown below, between the Board, Board Committees and Management Executive Committees, forms
                          the backbone of the Group’s Corporate Governance framework. As part of its decision-making
                          processes, the Board considers the long-term consequences of its decisions, the interests of
                          various stakeholders, including employees, the impact of the Group’s operations on the
                          environment and the need to conduct its business ethically. This is achieved through a prudent
                          and robust risk management framework, internal controls and strong governance processes.
                        </p>
                        <p>
                          Our Board provides strategic perspective and steers the business in line with the commitments
                          made to various stakeholders and sustainable growth. They are supported by:
                        </p>
                        <ul className="lists green-bullets">
                          <li>Established committees</li>
                          <li>Sustainable development team</li>
                          <li>Vedanta Sustainability Framework and Vedanta Sustainability</li>
                          <li>Assurance Process (VSAP)</li>
                          <li>Code of Business Conduct and Ethics</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column-45">
                  <div className="right-content">
                    <div className="right-to-left anim-6">
                      <CustomImage
                        className="custom-image"
                        imageName="by-overseeing.png"
                        alt=" Our Board"
                        maxWidth="613"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>

            <div className="content-row">
              <div className="column">
                <ScrollPositionAnimation targetElement2="anim-8">
                  <div className="flow-chart">
                    <div className="bottom-to-top anim-8">
                      <div className="desktop-img">
                        <CustomImage
                          className="custom-image"
                          imageName="business-sustainability-flow-chart.png"
                          alt="Our Board"
                          maxWidth="1200"
                        />
                      </div>
                      <div className="mobile-img">
                        <CustomImage
                          className="custom-image"
                          imageName="shareholders-chart.png"
                          alt="Our Board"
                          maxWidth="1200"
                        />
                      </div>
                    </div>
                  </div>
                </ScrollPositionAnimation>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="executive-committe">
        <div className="container">
          <div className="container-inner">
            <ScrollPositionAnimation targetElement2="anim-9">
              <div className="bottom-to-top anim-9">
                <div className="executive-committe-chart">
                  <div className="desktop-img">
                    <CustomImage
                      className="custom-image"
                      imageName="executive-committee-chart.png"
                      alt="Executive Committe Chart"
                      maxWidth="1200"
                    />
                  </div>
                  <div className="mobile-img">
                    <CustomImage
                      className="custom-image"
                      imageName="executive-committee-chart-mobile.png"
                      alt="Executive Committe Chart"
                      maxWidth="1200"
                    />
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
        <div className="executive-committe-bg"></div>
      </div>
    </div>
  );
};

export default FirmFoundationOurBoard;
